import { Box } from '@chakra-ui/react';

import { MobileUserNavigation } from '@r-client/republic/feature/layout';
import { MaybeValue, Viewer } from '@r-client/shared/data/auth';
import {
  E_US_ACCOUNT_ACCESS_STATE,
  useUsAccountAccessState,
} from '@r-client/shared/feature/global-auth';

interface IMobileUserMenuProps {
  user: {
    viewer: MaybeValue<Viewer>;
    isLoading?: boolean;
  };
  hasBottomBorder?: boolean;
}

export const MobileUserMenu = ({
  user: { viewer, isLoading },
  hasBottomBorder,
}: IMobileUserMenuProps) => {
  const { state: accessState } = useUsAccountAccessState(!!viewer?.info);

  if (!isLoading && accessState === E_US_ACCOUNT_ACCESS_STATE.SIGNED_OUT) {
    return null;
  }

  return (
    <Box
      borderTop="1px solid"
      borderBottom={hasBottomBorder ? '1px solid' : undefined}
      borderColor="grey.50"
    >
      <MobileUserNavigation user={viewer?.info} />
    </Box>
  );
};
